import { useMatch, usePathname } from 'app/routx-router'
import { useToken } from 'app/state'
import { isNil } from 'lodash-es'
import { styled } from 'styled-components'
import NavPanel from '../dashboard/components/common/NavPanel'

const ContentContainer = styled(Flex)`
  position: relative;
  align-items: stretch;
  flex: 1;
  overflow: hidden;
  height: 100%;
`

const AuthenticatedLayout: FC = ({ children }) => {
  const [token] = useToken()

  const pathname = usePathname()

  const accountMatch = useMatch('/me/*')
  const authMatch = useMatch('/auth/*')
  const plotCreation = useMatch('/farms/*/plots/create')
  const plotEdition = useMatch('/farms/*/plots/edit')
  const headquarterEdit = useMatch('/farms/*/admin/edit/headquarter')
  const onboarding = useMatch('/farms/*/onboarding/*')
  const addVWS = useMatch('/farms/*/add-virtual-weather-station')

  const isAcceptTOS = pathname === '/accept-tos'

  const showNav =
    !isNil(token) &&
    !accountMatch &&
    !authMatch &&
    !isAcceptTOS &&
    !plotCreation &&
    !plotEdition &&
    !headquarterEdit &&
    !onboarding &&
    !addVWS

  return (
    <>
      <Flex $height={'100vh'} $width={'100vw'}>
        {showNav ? <NavPanel /> : null}
        <ContentContainer $pointerEvents='auto'>{children}</ContentContainer>
      </Flex>
    </>
  )
}

export default AuthenticatedLayout
